import _has from 'lodash-es/has';
import _isObjectLike from 'lodash-es/isObjectLike';
import { BaseControl } from './base';
import { FormFieldOption, FormFieldSerializedValue } from '../form-field';

export class AutocompleteControl extends BaseControl {
  serializeValue(formControlValue: any | FormFieldOption | FormFieldOption[]): FormFieldSerializedValue {
    if (Array.isArray(formControlValue)) {
      return formControlValue.map(value => this.serializeValue(value));
    }

    const isAutocomplete = _has(formControlValue, 'value');
    if (isAutocomplete) {
      if (this.field.serializeTo) {
        return formControlValue[this.field.serializeTo];
      }

      return formControlValue.value;
    }

    return super.serializeValue(formControlValue);
  }

  unserializeValue(): any {
    if (!this.field.value) {
      return null;
    }

    // multiple
    if (Array.isArray(this.field.value)) {
      return this.field.value.map(value => this.unserializeSingleValue(value));
    }

    // single value
    if (_isObjectLike(this.field.value) && _has(this.field.value, 'label') && _has(this.field.value, 'value')) {
      return this.field.value;
    }

    return this.unserializeSingleValue(this.field.value);
  }

  protected getOptions(): { updateOn?: 'change' | 'blur' | 'submit' } {
    return {
      updateOn: 'change',
    };
  }

  private unserializeSingleValue(valueToParse: any): any {
    if (!valueToParse) {
      return null;
    }

    const matches = String(valueToParse).match(/(.+?) \[(\d+)\]$/);
    if (!matches) {
      return valueToParse;
    }

    const { 1: label, 2: value } = matches;

    return { label, value };
  }
}
